import React, { useCallback } from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { CSV_CELL_TYPES, ICON_NAMES, TABLE_VARIANTS, TEXT_ALIGNMENTS, TEXT_VARIANTS } from '../../../../constants'
import LinkSectionEmptyState from '../../../molecules/LinkSectionEmptyState'
import { fetchPersons } from '../../../../service'
import { useFetchState } from '../../../../hooks'
import { TableVirtualizedWithDynamicHeight } from '../../../molecules/Table'

const LABELS_COMMON_PROPS = {
  alignment: TEXT_ALIGNMENTS.left,
  colSpan: 1,
  variant: TEXT_VARIANTS.h3
}

const PERSONS_LABELS = [
  {
    ...LABELS_COMMON_PROPS,
    name: 'Name'
  },
  {
    ...LABELS_COMMON_PROPS,
    alignment: TEXT_ALIGNMENTS.right,
    name: 'User Role'
  }
]

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleContainer: {
    textAlign: 'left',
    marginBottom: theme.spacing(2)
  },
  spaceDivider: {
    minHeight: '1rem',
    width: '100%'
  },
  title: {
    textAlign: 'left',
    fontSize: '1.5rem'
  }
}))

const ClientPersons = ({ clientId }) => {
  const classes = useStyles()

  const {
    loading: loadingPersons,
    persons = []
  } = useFetchState(
    useCallback(
      async (safeSetState) => {
        try {
          const { data } = await fetchPersons({ clientIds: [clientId] })
          const persons = data.map(({ firstName, lastName, profilePic }) => [
            {
              alignment: TEXT_ALIGNMENTS.left,
              value: `${firstName} ${lastName}`,
              avatarSource: profilePic,
              withAvatar: true,
              csvData: { type: CSV_CELL_TYPES.string }
            },
            {
              alignment: TEXT_ALIGNMENTS.right,
              value: 'User',
              csvData: { type: CSV_CELL_TYPES.string }
            }
          ])
          safeSetState({ persons })
        } catch (error) {
          console.error(error)
          safeSetState({ error })
        }
      },
      [clientId]
    )
  )

  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        <Typography variant={TEXT_VARIANTS.h3} className={classes.title}>
          Persons
        </Typography>
      </div>
      {!loadingPersons && !persons.length ? (
        <LinkSectionEmptyState
          headerIconName={ICON_NAMES.bookmark}
          buttonLabel='Add Person'
        />
      ) : (
        !loadingPersons && (
          <TableVirtualizedWithDynamicHeight
            rows={persons}
            elementType='div'
            minHeight='30rem'
            virtualized
            variant={TABLE_VARIANTS.floatingHeader}
            labels={PERSONS_LABELS}
          />
        )
      )}
    </div>
  )
}

ClientPersons.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ClientPersons
